import React, { useEffect, useRef, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  CircularProgress,
  FormGroup,
  Grid,
  IconButton,
  Typography,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../component/button/button";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  CreateContractService,
  CreateCountryService,
  CreateProgramService,
  EditContractService,
} from "../../Redux/service/SettingService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { GetDegreeAction } from "../../Redux/action/ApplicationAction";
import { GetUniversityAction } from "../../Redux/action/SettingAction";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const CreateProgramPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const childRef = useRef(null);

  const { id } = useParams();

  const [Edit, setEdit] = useState(id ? true : false);

  const [Degreelist, setDegreelist] = useState([]);

  const [prefieldData, setPrefieldData] = useState();

  const [Universitylist, setUniversitylist] = useState([]);
  const [formLoading, setFormLoading] = useState(false);

  const EditCatalogdataState = useSelector(
    (state) => state.setting?.catalog?.data?.data
  );
  //(EditCatalogdataState);

  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );

  const DegreelistState = useSelector(
    (state) => state.application?.degree?.data?.degrees
  );

  const ContractTypeListState = useSelector(
    (state) => state.setting?.contractType?.data?.data
  );

  console.log(ContractTypeListState);

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetUniversityAction(data));
    dispatch(GetDegreeAction());
  }, []);

  useEffect(() => {
    setUniversitylist(
      UniversitylistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );

    setDegreelist(
      DegreelistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );
  }, [UniversitylistState, DegreelistState]);

  useEffect(() => {
    console.log(ContractTypeListState?.filter((data) => data._id === id)?.[0]);
    setPrefieldData(
      ContractTypeListState?.filter((data) => data._id === id)?.[0]
    );
  }, [Edit, ContractTypeListState, id]);

  const validationSchema = Yup.object({
    contractType: Yup.string().required("Name for contract is required"),
  });

  if (!prefieldData && Edit) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <CircularProgress color="inherit" />
      </div>
    ); // You can replace this with a loading spinner
  }

  return (
    <>
      <div className="d-flex align-items-center">
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          fontFamily={FontFamily.Poppins}
          fontWeight={fontWeight.W600}
          fontSize={fontSize.h2.small}
        >
          Settings
        </Typography>
        <Typography
          className="px-2 pt-1"
          fontFamily={FontFamily.Poppins}
          fontSize={fontSize.h4.medium}
          fontWeight={fontWeight.W300}
          color={ThemeColor.GREY}
        >
          {!Edit ? "Create" : "Edit"} Contract type
        </Typography>
      </div>
      <div className="container">
        <Formik
          initialValues={{
            contractType: Edit ? prefieldData?.contractType : "",
          }}
          // validationSchema={validationSchema}
          onSubmit={async (values, { ressetForm }) => {
            setFormLoading(true);
            if (!Edit) {
              await CreateContractService(values)
                .then((res) => {
                  if (res.status === 200) {
                    // //(res);
                    setFormLoading(false);

                    dispatch(showSnackbar(res.data.message, "success"));
                    navigate(`/CAE/ContractList`);

                    ressetForm();
                  }
                })

                .catch((e) => {
                  setFormLoading(false);
                  dispatch(showSnackbar(apiErrorMessage(e), "error"));
                });
            } else {
              await EditContractService(values, id)
                .then((res) => {
                  if (res.status === 200) {
                    // //(res);
                    setFormLoading(false);

                    dispatch(showSnackbar(res.data.message, "success"));
                    navigate("/CAE/ContractList");
                    ressetForm();
                  }
                })
                .catch((e) => {
                  setFormLoading(false);
                  dispatch(showSnackbar(apiErrorMessage(e), "error"));
                });
            }
          }}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <Form
              className="d-flex justify-content-center"
              onSubmit={handleSubmit}
            >
              <Box
                className="addcatalog-container"
                sx={{
                  width: { sm: "100%", xs: "100%", md: "80%", lg: "80%" },
                }}
              >
                <Typography
                  align="center"
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h3.medium}
                  color={ThemeColor.PURPLE}
                >
                  {!Edit ? "Add" : "Edit"} Contract Type
                </Typography>
                <FormGroup style={{}}>
                  <div className="">
                    <Typography
                      className="mb-2"
                      sx={{
                        fontWeight: 520,
                        fontSize: "0.9rem",
                        letterSpacing: "0.00938em",
                        fontFamily: "Lato !important",
                      }}
                    >
                      Contract Type Name *
                    </Typography>
                    <OutlinedInputField
                      value={values.contractType}
                      onChange={handleChange}
                      name={"contractType"}
                      placeholder="Enter your contract type name...."
                      fullWidth={true}
                      helperText={
                        <Typography
                          align="left"
                          // className="px-3"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.contractType}
                        </Typography>
                      }
                    />
                  </div>
                </FormGroup>
                <Box
                  sx={{
                    flexDirection: {
                      lg: "row",
                      md: "row",
                      sm: "column",
                      xs: "column",
                    },
                  }}
                  className="d-flex justify-content-center align-items-center h-100 w-100 mt-3"
                >
                  {" "}
                  <CustomButton
                    variant="contained"
                    type="submit"
                    color={ThemeColor.WHITE}
                    loading={formLoading}
                  //   padding={"0px"}
                  // onClick={handleClick}
                  >
                    {!Edit ? "Save" : "Edit"} Contract Type
                  </CustomButton>
                  <Box
                    className="px-2"
                    sx={{
                      paddingTop: {
                        lg: "0px",
                        md: "0px",
                        sm: "5px",
                        xs: "5px",
                      },
                    }}
                  >
                    {!Edit && (
                      <CustomButton
                        variant="contained"
                        // type="submit"
                        backgroundColor={ThemeColor.RED}
                        color={ThemeColor.WHITE}
                        loading={formLoading}
                        onClick={() => {
                          navigate("/CAE/SettingDashboard");
                        }}
                      >
                        Cancel Changes
                      </CustomButton>
                    )}
                  </Box>
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

function AddContractType() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<CreateProgramPage />} />
    </div>
  );
}

export default AddContractType;
